import React, { useEffect, useState } from "react";
import { Grid, Message, Segment } from "semantic-ui-react";

import { format, subDays } from "date-fns";
import Alerts from "utilities/Alerts";
import http from "utilities/http";

import "styles/Dashboard.css";

import TrendingProducts from "components/features/TrendingProducts";
import VendorMetadata from "components/features/VendorMetadata";
import StockDashboard from "components/features/StockDashboard";

function DashboardDisplay() {
	const [salesToday, setSalesToday] = useState([]);

	const today = format(new Date(), "yyyy-MM-dd");
	const tomorrow = format(subDays(new Date(), -1), "yyyy-MM-dd");
	useEffect(() => {
		http.get(`/report/sales/date/${today}/${tomorrow}`)
			.then((response) => {
				const records = response.data.records.reverse();

				if (records.length < 6) setSalesToday(records);
				else {
					const salesRecord = [];
					for (let i = 0; i < 6; i++) salesRecord.push(records[i]);
					setSalesToday(salesRecord);
				}
			})
			.catch((err) => Alerts.httpException(err));
	}, [today, tomorrow]);

	return (
		<Segment basic loading={false}>
			<Grid>
				<Grid.Column width={11}>
					<Grid>
						<Grid.Row columns={1}>
							<Grid.Column>
								<TrendingProducts />
							</Grid.Column>
						</Grid.Row>
						<Grid.Row columns={1}>
							<Grid.Column>
								<VendorMetadata />
							</Grid.Column>
						</Grid.Row>
					</Grid>
				</Grid.Column>

				<Grid.Column width={5}>
					<StockDashboard />
				</Grid.Column>
			</Grid>
			<div className="container">
				<div className="sales">
					<div className="header">
						<p>Latest Sales</p>
					</div>
					<div className="salesContent">
						{!salesToday.length ? (
							<Message content="No sales yet today." />
						) : (
							<table>
								<thead>
									<tr>
										<td>Name</td>
										<td>Item</td>
										<td className="center">Qty</td>
										<td className="right">Rate</td>
									</tr>
								</thead>
								<tbody>
									{salesToday.map((item) => (
										<tr key={item._id}>
											<td>{item.buyer}</td>
											<td>
												{item.productId?.name ??
													"item name not specified"}
											</td>
											<td className="center">
												{item.quantity}
											</td>
											<td className="right">
												{item.rate}
											</td>
										</tr>
									))}
								</tbody>
							</table>
						)}
					</div>
				</div>
			</div>
		</Segment>
	);
}

export default DashboardDisplay;
